import styled from 'styled-components';
import { colors, font, breakpoints, spacing } from '@chegg-ui/theme';
var dark = colors.dark,
  cheggOrange = colors.cheggOrange;
var family = font.family,
  _font$size = font.size,
  px14 = _font$size.px14,
  px16 = _font$size.px16,
  px18 = _font$size.px18,
  px20 = _font$size.px20,
  px24 = _font$size.px24,
  px28 = _font$size.px28,
  _font$weight = font.weight,
  medium = _font$weight.medium,
  bold = _font$weight.bold;
var max = breakpoints.sm.max;
export var SubscriptionInfoContainer = styled.div.withConfig({
  componentId: "sc-yqhq9c-0"
})(["font-family:", ";color:", ";"], family.aspira, dark);
export var Header = styled.h1.withConfig({
  componentId: "sc-yqhq9c-1"
})(["margin:0;font-weight:", ";", " .headerPriceSection{display:", ";", " &.withCoupon{font-weight:", ";strong{color:", ";}}}"], bold, function (_ref) {
  var dcoExperimentVariationEnabled = _ref.dcoExperimentVariationEnabled;
  if (dcoExperimentVariationEnabled) {
    return "\n            font-size: ".concat(px28, ";\n            @media (max-width: ").concat(breakpoints.md.max, ") {\n              font-size: ").concat(px20, ";\n            }\n          ");
  } else {
    return "\n            font-size: ".concat(px24, ";\n            @media (max-width: ").concat(max, ") {\n              font-size: ").concat(px18, ";\n            }\n          ");
  }
}, function (_ref2) {
  var dcoExperimentVariationEnabled = _ref2.dcoExperimentVariationEnabled;
  return dcoExperimentVariationEnabled ? 'block' : 'inline';
}, function (_ref3) {
  var dcoExperimentVariationEnabled = _ref3.dcoExperimentVariationEnabled;
  if (dcoExperimentVariationEnabled) {
    return "\n    margin-top: ".concat(spacing.px8, ";\n    font-size: ").concat(font.size.px22, ";\n    @media (max-width: ").concat(breakpoints.md.max, ") {\n        margin-top: ").concat(spacing.px24, ";\n        font-weight: ").concat(font.weight.medium, ";\n        font-size: ").concat(font.size.px20, ";\n      }\n    ");
  } else {
    return "\n            @media (max-width: ".concat(max, ") {\n      display: block;\n      margin-top: 8px;\n    }\n            ");
  }
}, medium, cheggOrange);
export var HeaderTaxInfo = styled.span.withConfig({
  componentId: "sc-yqhq9c-2"
})(["font-weight:", ";font-size:", ";"], medium, px16);
export var Subheader = styled.p.withConfig({
  componentId: "sc-yqhq9c-3"
})(["margin-top:10px;font-size:", ";@media (max-width:", "){font-size:", ";}"], px16, max, px14);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/SubscriptionInfo/styled.js
// module id = 3995
// module chunks = 11